/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2024] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 23/Jul/2024.
 */

package com.narbase.letsgo.deployment

@Suppress("unused")
enum class Environment { Dev, Prod, Staging, RunningLocalTests }